(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastCartTrigger = null;
  var lastMenuTrigger = null;
  var lastFilterTrigger = null;
  var lastSearchTrigger = null;
  var lastMfpTrigger = null;
  var atcPending = false;
  var cartWasOpen = false;
  var menuWasOpen = false;
  var filterWasOpen = false;
  var searchWasOpen = false;
  var submenuIdCounter = 0;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function setInert(el, makeInert) {
    if (!el) return;
    if (makeInert) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      if (el.closest('[inert]')) return false;
      return el.getClientRects().length > 0;
    });
  }

  function focusFirst(container, preferredSelectors) {
    if (!container) return;
    window.requestAnimationFrame(function () {
      var target = null;
      if (preferredSelectors) {
        for (var i = 0; i < preferredSelectors.length; i++) {
          target = container.querySelector(preferredSelectors[i]);
          if (target) break;
        }
      }
      if (!target) target = getFocusable(container)[0] || container;
      if (target && typeof target.focus === 'function') {
        try {
          target.focus();
        } catch (e) {}
      }
    });
  }

  function restoreFocus(trigger) {
    if (trigger && typeof trigger.focus === 'function') {
      try {
        trigger.focus();
      } catch (e) {}
    }
  }

  function trapFocusIn(container, event) {
    if (event.key !== 'Tab' || !container || container.hasAttribute('inert')) return;
    var list = getFocusable(container);
    if (!list.length) {
      event.preventDefault();
      if (typeof container.focus === 'function') container.focus();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || !container.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !container.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  function ensureSubmenuId(submenu) {
    if (!submenu.id) {
      submenuIdCounter += 1;
      submenu.id = 'MobileSubmenu-' + submenuIdCounter;
    }
    return submenu.id;
  }

  function syncMobileSubmenus() {
    var items = document.querySelectorAll('.jas-canvas-menu li.has-sub');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var submenu = null;
      var toggle = null;
      var children = item.children;
      for (var c = 0; c < children.length; c++) {
        if (children[c].tagName === 'UL') submenu = children[c];
        if (children[c].tagName === 'A' && children[c].classList.contains('holderr')) {
          toggle = children[c];
        }
      }
      if (!submenu) continue;
      var isOpen = item.classList.contains('open');
      setInert(submenu, !isOpen);
      if (toggle) {
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.setAttribute('aria-haspopup', 'true');
        toggle.setAttribute('aria-controls', ensureSubmenuId(submenu));
      }
    }
  }

  function syncMobileDrawer() {
    var canvas = document.querySelector('.jas-canvas-menu');
    var menuOpen = document.body.classList.contains('menu-opened');
    var toggle = document.querySelector('.jas-push-menu-btn');
    setInert(canvas, !menuOpen);
    if (toggle) {
      toggle.setAttribute('aria-expanded', menuOpen ? 'true' : 'false');
    }
    if (menuOpen) {
      syncMobileSubmenus();
    }
  }

  function closeCart() {
    document.body.classList.remove('cart-opened');
  }

  function closeMenu() {
    document.body.classList.remove('menu-opened');
  }

  function closeFilter() {
    var wrap = document.querySelector('.jas-filter-wrap.opened');
    var btn = document.querySelector('.jas_pop_sidebar.opened');
    if (wrap) wrap.classList.remove('opened');
    if (btn) btn.classList.remove('opened');
  }

  function getFilterSidebar() {
    return document.querySelector('.jas-filter-wrap .filter-sidebar');
  }

  function closeSearch() {
    document.body.classList.remove('gecko-search-opened');
    var hs = document.querySelector('.header__search');
    if (hs && hs.style.display === 'block') {
      hs.style.display = 'none';
    }
    var wrapper = document.querySelector('.wrapper-search-dropdown');
    if (wrapper) wrapper.classList.remove('search-overlap');
  }

  function onCartOpenChange(isOpen) {
    var drawer = document.querySelector('.jas-mini-cart');
    if (!drawer) return;

    if (isOpen) {
      setInert(drawer, false);
      if (!drawer.getAttribute('role')) drawer.setAttribute('role', 'dialog');
      if (!drawer.getAttribute('aria-modal')) drawer.setAttribute('aria-modal', 'true');
      focusFirst(drawer, ['.close-cart', '#CartDrawer-Heading', '#CartDrawer-Title']);
    } else {
      setInert(drawer, true);
      restoreFocus(lastCartTrigger);
      atcPending = false;
    }
  }

  function onMenuOpenChange(isOpen) {
    syncMobileDrawer();
    var canvas = document.querySelector('.jas-canvas-menu');
    if (!canvas) return;
    if (isOpen) {
      if (!lastMenuTrigger) {
        lastMenuTrigger = document.querySelector('.jas-push-menu-btn');
      }
      focusFirst(canvas, ['.close-menu', '.jas-mobile-tabs h3.active', '.jas_ui_menu.active a']);
    } else {
      restoreFocus(lastMenuTrigger || document.querySelector('.jas-push-menu-btn'));
      lastMenuTrigger = null;
    }
  }

  function onFilterOpenChange(isOpen) {
    var sidebar = getFilterSidebar();
    var wrap = document.querySelector('.jas-filter-wrap');
    if (!sidebar || !document.querySelector('.jas_pop_sidebar')) return;
    /* Never put inert on .jas-filter-wrap — it wraps the product grid */
    if (wrap) wrap.removeAttribute('inert');
    if (isOpen) {
      sidebar.setAttribute('role', 'dialog');
      sidebar.setAttribute('aria-modal', 'true');
      if (!sidebar.getAttribute('aria-label') && !sidebar.getAttribute('aria-labelledby')) {
        sidebar.setAttribute('aria-label', 'Filters');
      }
      if (!sidebar.hasAttribute('tabindex')) sidebar.setAttribute('tabindex', '-1');
      setInert(sidebar, false);
      focusFirst(sidebar, ['.close-filter', 'h3', 'a', 'button', 'input']);
    } else {
      setInert(sidebar, true);
      restoreFocus(lastFilterTrigger);
      lastFilterTrigger = null;
    }
  }

  function getSearchPanel() {
    return (
      document.querySelector('.header__search') ||
      document.querySelector('.wrapper-search-dropdown') ||
      null
    );
  }

  function onSearchOpenChange(isOpen) {
    var panel = getSearchPanel();
    if (!panel) return;
    if (isOpen) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      if (!panel.getAttribute('aria-label')) {
        panel.setAttribute('aria-label', 'Search');
      }
      focusFirst(panel, ['input[type="text"]', 'input[name="q"]', '#sf-close', '.gecko-close-search']);
    } else {
      restoreFocus(lastSearchTrigger);
      lastSearchTrigger = null;
    }
  }

  function enhanceMfpContent(content) {
    if (!content) return;
    content.setAttribute('role', 'dialog');
    content.setAttribute('aria-modal', 'true');
    if (!content.getAttribute('aria-label') && !content.getAttribute('aria-labelledby')) {
      var heading = content.querySelector('h1, h2, h3, .ypop-title, .product_title, .mfp-title');
      if (heading) {
        if (!heading.id) heading.id = 'MfpDialogHeading';
        content.setAttribute('aria-labelledby', heading.id);
      } else {
        content.setAttribute('aria-label', 'Dialog');
      }
    }
    if (!content.hasAttribute('tabindex')) content.setAttribute('tabindex', '-1');
    focusFirst(content, ['.mfp-close', 'button', 'a', 'input']);
  }

  function trapCartFocus(event) {
    if (!document.body.classList.contains('cart-opened')) return;
    trapFocusIn(document.querySelector('.jas-mini-cart'), event);
  }

  function trapMenuFocus(event) {
    if (!document.body.classList.contains('menu-opened')) return;
    trapFocusIn(document.querySelector('.jas-canvas-menu'), event);
  }

  function trapFilterFocus(event) {
    var wrap = document.querySelector('.jas-filter-wrap.opened');
    var sidebar = getFilterSidebar();
    if (!wrap || !sidebar) return;
    trapFocusIn(sidebar, event);
  }

  function trapSearchFocus(event) {
    if (!document.body.classList.contains('gecko-search-opened')) {
      var hs = document.querySelector('.header__search');
      if (!hs || hs.style.display !== 'block') return;
      trapFocusIn(hs, event);
      return;
    }
    trapFocusIn(getSearchPanel(), event);
  }

  function trapMfpFocus(event) {
    var content = document.querySelector('.mfp-content');
    var wrap = document.querySelector('.mfp-wrap');
    if (!wrap || !content || wrap.classList.contains('mfp-removing')) return;
    trapFocusIn(content, event);
  }

  /* ---------- Desktop mega menu keyboard support ---------- */

  function getTopLevelNavLinks() {
    return document.querySelectorAll(
      '#jas-main-menu > li > a, .jas-menu > li > a, ul.jas-menu > li > a'
    );
  }

  function getSubmenuForTopLink(link) {
    var li = link && link.parentElement;
    if (!li || li.tagName !== 'LI') return null;
    var children = li.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName === 'UL') return children[i];
    }
    return null;
  }

  function setNavExpanded(link, expanded) {
    if (!link) return;
    link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function initMegaMenuA11y() {
    var links = getTopLevelNavLinks();
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('data-a11y-nav') === '1') continue;
      var submenu = getSubmenuForTopLink(link);
      if (!submenu) continue;
      link.setAttribute('data-a11y-nav', '1');
      link.setAttribute('aria-haspopup', 'true');
      setNavExpanded(link, false);
    }
  }

  function syncNavExpandedFromFocus() {
    var links = getTopLevelNavLinks();
    var active = document.activeElement;
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('data-a11y-nav') !== '1') continue;
      var li = link.parentElement;
      var open = !!(li && active && li.contains(active));
      setNavExpanded(link, open);
    }
  }

  function handleMegaMenuEscape(event) {
    if (event.key !== 'Escape') return;
    if (document.body.classList.contains('cart-opened')) return;
    if (document.body.classList.contains('menu-opened')) return;

    var active = document.activeElement;
    if (!active) return;

    var li = active.closest && active.closest('.jas-menu > li, #jas-main-menu > li, ul.jas-menu > li');
    if (!li) return;

    var topLink = null;
    for (var i = 0; i < li.children.length; i++) {
      if (li.children[i].tagName === 'A') {
        topLink = li.children[i];
        break;
      }
    }
    if (!topLink || topLink.getAttribute('data-a11y-nav') !== '1') return;

    var submenu = getSubmenuForTopLink(topLink);
    if (!submenu) return;

    if (submenu.contains(active) && active !== topLink) {
      event.preventDefault();
      topLink.focus();
      setNavExpanded(topLink, true);
      return;
    }

    if (active === topLink) {
      event.preventDefault();
      topLink.blur();
      setNavExpanded(topLink, false);
    }
  }

  /* ---------- Variant swatch keyboard support ---------- */

  function getAllSwatches(list) {
    return Array.prototype.filter.call(list.children, function (el) {
      return el.nodeType === 1 && el.classList.contains('gecko-swatch');
    });
  }

  function getSwatchOptions(list) {
    return getAllSwatches(list).filter(function (el) {
      return !el.classList.contains('jas_unavailable');
    });
  }

  function findSelectedSwatch(all) {
    var i;
    for (i = 0; i < all.length; i++) {
      if (all[i].classList.contains('is-selected')) return all[i];
    }
    for (i = 0; i < all.length; i++) {
      if (all[i].classList.contains('is-selected-none')) return all[i];
    }
    return null;
  }

  function syncSwatchGroup(list) {
    if (!list || list.getAttribute('role') !== 'radiogroup') return;
    var all = getAllSwatches(list);
    if (!all.length) return;

    /*
     * Every available swatch stays in the tab order (tabindex=0).
     * Roving tabindex only on the selected option caused Tab to skip
     * M/L/XL and land on the plus-size <a> links that sit in the same list.
     */
    var selected = findSelectedSwatch(all);

    for (var j = 0; j < all.length; j++) {
      var opt = all[j];
      var unavailable = opt.classList.contains('jas_unavailable');
      var checked = selected ? opt === selected : false;
      opt.setAttribute('role', 'radio');
      opt.setAttribute('aria-checked', checked ? 'true' : 'false');
      if (unavailable) {
        opt.setAttribute('aria-disabled', 'true');
        opt.setAttribute('tabindex', '-1');
      } else {
        opt.removeAttribute('aria-disabled');
        opt.setAttribute('tabindex', '0');
      }
    }
  }

  function enhanceSwatchList(list) {
    if (!list || list.getAttribute('data-a11y-swatch') === '1') {
      syncSwatchGroup(list);
      return;
    }

    list.setAttribute('data-a11y-swatch', '1');
    list.setAttribute('role', 'radiogroup');

    var title = list.parentElement && list.parentElement.querySelector('.swatch__title');
    if (title) {
      var labelText = (title.textContent || '').replace(/\s+/g, ' ').trim();
      if (labelText) {
        list.setAttribute('aria-label', labelText.split(':')[0].trim() || labelText);
      }
    }

    var options = Array.prototype.filter.call(list.children, function (el) {
      return el.nodeType === 1 && el.classList.contains('gecko-swatch');
    });
    for (var i = 0; i < options.length; i++) {
      options[i].setAttribute('role', 'radio');
    }

    syncSwatchGroup(list);

    list.addEventListener('keydown', function (event) {
      var target = event.target.closest && event.target.closest('.gecko-swatch');
      if (!target || !list.contains(target)) return;

      var keys = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End', ' ', 'Enter'];
      if (keys.indexOf(event.key) === -1) return;

      var opts = getSwatchOptions(list);
      if (!opts.length) return;

      var index = opts.indexOf(target);
      if (index < 0) return;

      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        target.click();
        syncSwatchGroup(list);
        return;
      }

      var next = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = (index + 1) % opts.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = (index - 1 + opts.length) % opts.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = opts.length - 1;
      }

      if (next === index) return;
      event.preventDefault();
      opts[next].click();
      syncSwatchGroup(list);
      if (typeof opts[next].focus === 'function') opts[next].focus();
    });

    list.addEventListener('click', function () {
      window.setTimeout(function () {
        syncSwatchGroup(list);
      }, 0);
    });
  }

  function enhanceAllSwatches(root) {
    var scope = root || document;
    var lists = scope.querySelectorAll
      ? scope.querySelectorAll('ul.swatches-select')
      : [];
    for (var i = 0; i < lists.length; i++) {
      enhanceSwatchList(lists[i]);
    }
  }

  /* ---------- Slick carousel ARIA (strip invalid listbox) ---------- */

  function findCarouselLabel(slider) {
    var section =
      slider.closest('[id^="shopify-section-"], .jas-section') ||
      slider.closest('[class*="jas_custom_"]') ||
      slider.parentElement;
    var heading = null;
    if (section) {
      heading = section.querySelector('.jas_title_1, .jas_title, h2, h1');
    }
    if (!heading && slider.parentElement) {
      heading = slider.parentElement.querySelector('.jas_title_1, .jas_title, h2, h1');
    }
    if (heading) {
      var clone = heading.cloneNode(true);
      var subs = clone.querySelectorAll('.sub-title');
      for (var s = 0; s < subs.length; s++) {
        subs[s].parentNode.removeChild(subs[s]);
      }
      var text = (clone.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) return text;
    }
    return 'Product carousel';
  }

  var SLIDE_FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

  function syncHiddenSlideFocusables(slide) {
    if (!slide || !slide.querySelectorAll) return;
    var hide = slide.getAttribute('aria-hidden') === 'true';
    var nodes = slide.querySelectorAll(SLIDE_FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      /* Do not leave the slide itself with conflicting tab state */
      if (el === slide) continue;
      if (hide) {
        if (!el.hasAttribute('data-a11y-tb')) {
          el.setAttribute(
            'data-a11y-tb',
            el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '__none__'
          );
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-a11y-tb')) {
        var prev = el.getAttribute('data-a11y-tb');
        el.removeAttribute('data-a11y-tb');
        if (prev === '__none__') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', prev);
        }
      }
    }
  }

  function fixSlickAria(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll
      ? scope.querySelectorAll('.slick-slider, .jas-carousel.slick-initialized')
      : [];
    for (var i = 0; i < sliders.length; i++) {
      var slider = sliders[i];
      if (!slider.classList.contains('slick-initialized') && !slider.querySelector('.slick-track')) {
        continue;
      }
      if (!slider.getAttribute('aria-label') && !slider.getAttribute('aria-labelledby')) {
        slider.setAttribute('role', 'region');
        slider.setAttribute('aria-label', findCarouselLabel(slider));
      } else if (!slider.getAttribute('role') || slider.getAttribute('role') === 'listbox') {
        slider.setAttribute('role', 'region');
      }

      var track = slider.querySelector('.slick-track');
      if (track && track.getAttribute('role') === 'listbox') {
        track.removeAttribute('role');
      }

      var slides = slider.querySelectorAll('.slick-slide');
      for (var j = 0; j < slides.length; j++) {
        if (slides[j].getAttribute('role') === 'option') {
          slides[j].removeAttribute('role');
        }
        syncHiddenSlideFocusables(slides[j]);
      }
    }
  }

  /* ---------- Klaviyo decorative images missing alt ---------- */

  function fixKlaviyoImageAlts(root) {
    var scope = root || document;
    var imgs = scope.querySelectorAll
      ? scope.querySelectorAll('img.needsclick, .needsclick img')
      : [];
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].hasAttribute('alt')) {
        imgs[i].setAttribute('alt', '');
      }
    }
  }

  /* ---------- Iframes missing title (e.g. Shopify #PBarNextFrame) ---------- */

  function fixIframeTitles(root) {
    var scope = root || document;
    var frames = scope.querySelectorAll ? scope.querySelectorAll('iframe') : [];
    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i];
      if (frame.hasAttribute('title') && frame.getAttribute('title').trim() !== '') continue;
      var id = frame.id || '';
      var src = frame.getAttribute('src') || '';
      var label = 'Embedded content';
      if (id === 'PBarNextFrame' || id.indexOf('preview-bar') !== -1 || src.indexOf('preview_bar') !== -1) {
        label = 'Theme preview bar';
      } else if (src.indexOf('youtube.com') !== -1 || src.indexOf('youtu.be') !== -1) {
        label = 'YouTube video';
      } else if (src.indexOf('vimeo.com') !== -1) {
        label = 'Vimeo video';
      } else if (src.indexOf('google.com/maps') !== -1 || src.indexOf('maps.google') !== -1) {
        label = 'Google Map';
      } else if (frame.getAttribute('name')) {
        label = frame.getAttribute('name');
      } else if (id) {
        label = id.replace(/[-_]/g, ' ');
      }
      frame.setAttribute('title', label);
    }
  }

  ready(function () {
    var canvas = document.querySelector('.jas-canvas-menu');
    var drawer = document.querySelector('.jas-mini-cart');
    var filterWrap = document.querySelector('.jas-filter-wrap');

    if (drawer) {
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      if (!drawer.getAttribute('aria-labelledby') && !drawer.getAttribute('aria-label')) {
        drawer.setAttribute('aria-labelledby', 'CartDrawer-Title');
      }
      if (!drawer.hasAttribute('tabindex')) {
        drawer.setAttribute('tabindex', '-1');
      }
    }

    if (canvas) {
      if (!canvas.getAttribute('role')) canvas.setAttribute('role', 'dialog');
      if (!canvas.getAttribute('aria-modal')) canvas.setAttribute('aria-modal', 'true');
      if (!canvas.hasAttribute('tabindex')) canvas.setAttribute('tabindex', '-1');
    }

    var usesFilterDrawer = !!document.querySelector('.jas_pop_sidebar');
    var filterSidebar = getFilterSidebar();
    if (filterSidebar && usesFilterDrawer) {
      /* Clear inert if it was wrongly applied to the product-grid wrapper */
      if (filterWrap) filterWrap.removeAttribute('inert');
      if (!filterWrap || !filterWrap.classList.contains('opened')) {
        setInert(filterSidebar, true);
      }
    } else if (filterWrap) {
      filterWrap.removeAttribute('inert');
    }

    /* Make icon-only close controls keyboard-accessible */
    function enhanceIconControls() {
      var closes = document.querySelectorAll('.close-filter, .close-menu');
      for (var i = 0; i < closes.length; i++) {
        var el = closes[i];
        if (el.getAttribute('data-a11y-close') === '1') continue;
        el.setAttribute('data-a11y-close', '1');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.getAttribute('role')) el.setAttribute('role', 'button');
        if (!el.getAttribute('aria-label')) {
          el.setAttribute('aria-label', el.classList.contains('close-filter') ? 'Close filters' : 'Close menu');
        }
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.currentTarget.click();
          }
        });
      }
      var searchOpens = document.querySelectorAll('.sf-open');
      for (var s = 0; s < searchOpens.length; s++) {
        var so = searchOpens[s];
        if (so.getAttribute('data-a11y-search') === '1') continue;
        so.setAttribute('data-a11y-search', '1');
        if (!so.getAttribute('role') && so.tagName !== 'A' && so.tagName !== 'BUTTON') {
          so.setAttribute('role', 'button');
        }
        if (!so.getAttribute('aria-label')) so.setAttribute('aria-label', 'Search');
        if (!so.hasAttribute('tabindex') && so.tagName !== 'A' && so.tagName !== 'BUTTON') {
          so.setAttribute('tabindex', '0');
        }
      }
    }
    enhanceIconControls();

    cartWasOpen = document.body.classList.contains('cart-opened');
    menuWasOpen = document.body.classList.contains('menu-opened');
    filterWasOpen = !!(filterWrap && filterWrap.classList.contains('opened'));
    searchWasOpen = document.body.classList.contains('gecko-search-opened');
    syncMobileDrawer();
    syncMobileSubmenus();
    setInert(drawer, !cartWasOpen);

    initMegaMenuA11y();
    enhanceAllSwatches(document);
    fixSlickAria(document);
    fixKlaviyoImageAlts(document);
    fixIframeTitles(document);
    window.setTimeout(function () {
      fixSlickAria(document);
      fixKlaviyoImageAlts(document);
      fixIframeTitles(document);
      syncMobileSubmenus();
    }, 1500);
    window.setTimeout(function () {
      fixSlickAria(document);
      fixKlaviyoImageAlts(document);
      fixIframeTitles(document);
    }, 4000);

    document.addEventListener(
      'click',
      function (event) {
        var atc = event.target.closest('.ajax_form_cart, .ajax_add_to_cart, .shopify_add_to_cart');
        if (atc) {
          lastCartTrigger = atc;
          atcPending = true;
          return;
        }
        var cartLink = event.target.closest('.jas-sidebar-cart > a, .cart-contents');
        if (cartLink && !atcPending) {
          lastCartTrigger = cartLink;
        }
        var menuBtn = event.target.closest('.jas-push-menu-btn');
        if (menuBtn) {
          lastMenuTrigger = menuBtn;
        }
        var filterBtn = event.target.closest('.jas_pop_sidebar, #jas-filter');
        if (filterBtn) {
          lastFilterTrigger = filterBtn;
        }
        var searchBtn = event.target.closest('.sf-open, .gecko-search-dropdown');
        if (searchBtn) {
          lastSearchTrigger = searchBtn;
        }
        var mfpTrigger = event.target.closest(
          '.open-quick-view, .jas-magnific-image, .jas-wc-help, .jas-popup-url, a[href="#delivery-return"]'
        );
        if (mfpTrigger) {
          lastMfpTrigger = mfpTrigger;
        }
      },
      true
    );

    document.addEventListener('focusin', function () {
      syncNavExpandedFromFocus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (document.body.classList.contains('cart-opened')) {
          event.preventDefault();
          closeCart();
          return;
        }
        if (document.body.classList.contains('menu-opened')) {
          event.preventDefault();
          closeMenu();
          return;
        }
        if (document.querySelector('.jas-filter-wrap.opened')) {
          event.preventDefault();
          closeFilter();
          return;
        }
        if (
          document.body.classList.contains('gecko-search-opened') ||
          (document.querySelector('.header__search') &&
            document.querySelector('.header__search').style.display === 'block')
        ) {
          event.preventDefault();
          closeSearch();
          return;
        }
        handleMegaMenuEscape(event);
        return;
      }
      if (event.key === 'Tab') {
        trapCartFocus(event);
        trapMenuFocus(event);
        trapFilterFocus(event);
        trapSearchFocus(event);
        trapMfpFocus(event);
      }
    });

    new MutationObserver(function () {
      var cartOpen = document.body.classList.contains('cart-opened');
      var menuOpen = document.body.classList.contains('menu-opened');
      var searchOpen = document.body.classList.contains('gecko-search-opened');
      if (cartOpen !== cartWasOpen) {
        cartWasOpen = cartOpen;
        onCartOpenChange(cartOpen);
      }
      if (menuOpen !== menuWasOpen) {
        menuWasOpen = menuOpen;
        onMenuOpenChange(menuOpen);
      }
      if (searchOpen !== searchWasOpen) {
        searchWasOpen = searchOpen;
        onSearchOpenChange(searchOpen);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (canvas) {
      new MutationObserver(function () {
        if (document.body.classList.contains('menu-opened')) {
          syncMobileSubmenus();
        }
      }).observe(canvas, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    if (filterWrap && usesFilterDrawer) {
      new MutationObserver(function () {
        var open = filterWrap.classList.contains('opened');
        if (open !== filterWasOpen) {
          filterWasOpen = open;
          onFilterOpenChange(open);
        }
      }).observe(filterWrap, { attributes: true, attributeFilter: ['class'] });
    }

    /* Magnific Popup: dialog semantics + focus restore */
    if (window.jQuery) {
      jQuery(document).on('mfpOpen', function () {
        var content = document.querySelector('.mfp-content');
        enhanceMfpContent(content);
      });
      jQuery(document).on('mfpClose', function () {
        restoreFocus(lastMfpTrigger);
        lastMfpTrigger = null;
      });
    }

    /* Full-screen search open/close via display changes */
    var hs = document.querySelector('.header__search');
    if (hs) {
      new MutationObserver(function () {
        var open = hs.style.display === 'block' || window.getComputedStyle(hs).display !== 'none';
        /* only treat as open when takeover is visible (not display:none class dn alone) */
        var visiblyOpen = hs.offsetParent !== null || hs.style.display === 'block';
        if (visiblyOpen && !searchWasOpen && !document.body.classList.contains('gecko-search-opened')) {
          searchWasOpen = true;
          onSearchOpenChange(true);
        } else if (!visiblyOpen && searchWasOpen && !document.body.classList.contains('gecko-search-opened')) {
          searchWasOpen = false;
          onSearchOpenChange(false);
        }
      }).observe(hs, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    /* Quick view / AJAX / Slick / Klaviyo inject content after load */
    var slickFixTimer = null;
    var klaviyoFixTimer = null;
    var iframeFixTimer = null;
    function scheduleSlickFix() {
      if (slickFixTimer) return;
      slickFixTimer = window.setTimeout(function () {
        slickFixTimer = null;
        fixSlickAria(document);
      }, 50);
    }
    function scheduleKlaviyoFix() {
      if (klaviyoFixTimer) return;
      klaviyoFixTimer = window.setTimeout(function () {
        klaviyoFixTimer = null;
        fixKlaviyoImageAlts(document);
      }, 50);
    }
    function scheduleIframeFix() {
      if (iframeFixTimer) return;
      iframeFixTimer = window.setTimeout(function () {
        iframeFixTimer = null;
        fixIframeTitles(document);
      }, 50);
    }

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes') {
          if (mutation.attributeName === 'role' || mutation.attributeName === 'aria-hidden') {
            scheduleSlickFix();
          }
          continue;
        }
        var nodes = mutation.addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('ul.swatches-select')) {
            enhanceSwatchList(node);
          } else if (node.querySelectorAll) {
            enhanceAllSwatches(node);
          }
          if (node.matches && (node.matches('.jas-menu') || node.matches('#jas-main-menu') || node.querySelector('.jas-menu'))) {
            initMegaMenuA11y();
          }
          if (
            (node.matches && (node.matches('.slick-slider') || node.matches('.slick-track') || node.classList.contains('jas-carousel'))) ||
            (node.querySelector && node.querySelector('.slick-track, .slick-slider'))
          ) {
            scheduleSlickFix();
          }
          if (
            (node.matches && (node.matches('img.needsclick') || node.matches('.needsclick'))) ||
            (node.querySelector && node.querySelector('img.needsclick, .needsclick img'))
          ) {
            scheduleKlaviyoFix();
          }
          if (
            (node.matches && node.matches('iframe')) ||
            (node.querySelector && node.querySelector('iframe'))
          ) {
            scheduleIframeFix();
          }
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'aria-hidden'],
    });
  });
})();
